import 'css-chunksrc/client/scenes/workloads/wbsHeader/styles.scss';export default {
  "wbsHeader": "_wbsHeader_1hp6k_1",
  "detailsViewToggle": "_detailsViewToggle_1hp6k_14",
  "action": "_action_1hp6k_26",
  "text": "_text_1hp6k_39",
  "icon": "_icon_1hp6k_46",
  "details": "_details_1hp6k_14",
  "detail": "_detail_1hp6k_14",
  "open": "_open_1hp6k_83",
  "header": "_header_1hp6k_90",
  "row": "_row_1hp6k_99",
  "label": "_label_1hp6k_109"
};